import React from 'react'
import OtherChargesAdd from './OtherChargesAdd'

const OtherCharges = () => {
    return (
        <OtherChargesAdd />
    )
}

export default OtherCharges